import { render, staticRenderFns } from "./ModalResolved.vue?vue&type=template&id=26815508&"
import script from "./ModalResolved.vue?vue&type=script&lang=js&"
export * from "./ModalResolved.vue?vue&type=script&lang=js&"
import style0 from "./ModalResolved.vue?vue&type=style&index=0&id=26815508&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports